import React from 'react';
import Icon from 'components/AppIcon';

const TIER_CONFIG = {
  SEASONAL_BRONZE: {
    label: 'Bronze',
    color: 'text-amber-600',
    bg: 'bg-amber-600/10 border-amber-600/20',
    icon: 'Award',
    placement: 'Top 50%',
  },
  SEASONAL_SILVER: {
    label: 'Silver',
    color: 'text-slate-300',
    bg: 'bg-slate-300/10 border-slate-300/20',
    icon: 'Award',
    placement: 'Top 25%',
  },
  SEASONAL_GOLD: {
    label: 'Gold',
    color: 'text-yellow-500',
    bg: 'bg-yellow-500/10 border-yellow-500/20',
    icon: 'Star',
    placement: 'Top 10%',
  },
  SEASONAL_LEGEND: {
    label: 'Legend',
    color: 'text-yellow-300',
    bg: 'bg-yellow-300/10 border-yellow-300/20',
    icon: 'Crown',
    placement: 'Top 1%',
  },
};

const SKIN_ICONS = {
  PROFILE_THEME: 'UserCircle',
  UI_THEME: 'Palette',
  AVATAR_FRAME: 'Image',
  FACTION_BANNER: 'Flag',
  CHART_STYLE: 'BarChart2',
};

const CosmeticRewards = ({ rewards, loading }) => {
  if (loading) {
    return (
      <div className="card p-6 animate-pulse">
        <div className="h-4 bg-surface-700 rounded w-1/2 mb-4" />
        <div className="grid grid-cols-2 gap-3">
          {[...Array(4)]?.map((_, i) => (
            <div key={i} className="h-24 bg-surface-700 rounded" />
          ))}
        </div>
      </div>
    );
  }

  const displayRewards = rewards?.length > 0 ? rewards : Object.entries(TIER_CONFIG)?.map(([tier, cfg]) => ({
    id: tier,
    reward_name: `${cfg?.label} Season Reward`,
    reward_tier: tier,
    skin_type: 'PROFILE_THEME',
    description: `Exclusive cosmetic for ${cfg?.placement} finishers`,
  }));

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-bold text-foreground flex items-center gap-2">
          <Icon name="Gift" size={18} className="text-accent" />
          Seasonal Rewards
        </h3>
        <span className="text-xs text-muted">End of season</span>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {displayRewards?.map((reward) => {
          const tierCfg = TIER_CONFIG?.[reward?.reward_tier] || TIER_CONFIG?.SEASONAL_BRONZE;
          const skinIcon = SKIN_ICONS?.[reward?.skin_type] || 'Gift';
          return (
            <div
              key={reward?.id}
              className={`p-3 rounded-lg border ${tierCfg?.bg} transition-all hover:scale-[1.02]`}
            >
              <div className="flex items-center gap-2 mb-2">
                <Icon name={tierCfg?.icon} size={16} className={tierCfg?.color} />
                <span className={`text-xs font-bold ${tierCfg?.color}`}>{tierCfg?.label}</span>
              </div>
              <div className="flex items-center gap-1.5 mb-1">
                <Icon name={skinIcon} size={14} className="text-muted" />
                <p className="text-xs font-medium text-foreground truncate">{reward?.reward_name}</p>
              </div>
              <p className="text-xs text-muted">{reward?.description}</p>
              <div className="mt-2 pt-2 border-t border-white/5">
                <span className="text-xs text-muted">Unlock: </span>
                <span className={`text-xs font-medium ${tierCfg?.color}`}>{tierCfg?.placement}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CosmeticRewards;
